export default __webpack_public_path__ + "static/media/profilePicture.0090412a.jpg";